import React, {Component} from 'react';
import Card from "../Card";
import s from './CardList.module.scss'
import {Input} from "antd";
import getTranslateWord from "../../services/dictionary";

const {Search} = Input;

export const hoc = (Component, items, onDeletedItem) => {
    return class extends React.PureComponent {
        state = {
            value: '',
            label: '',
            isBusy: false,
        }

        handleInputChange = (e) => {
            this.setState({
                value: e.target.value,
            });
        }

        getTheWord = async () => {
            const {value} = this.state;
            const getWord = await getTranslateWord(this.state.value);
            this.setState({
                label: `${value} - ${getWord.translate}`,
                value: '',
                isBusy: false,
            });
        }

        handleSubmitForm = async () => {
            this.setState({
                isBusy: true,
            }, this.getTheWord)

        }

        render() {

            const {value, label, isBusy} = this.state;
            return (
                <>
                    <div>
                        {label}
                    </div>
                    <div className={s.form}>
                        <Search
                            placeholder="input search text"
                            enterButton="Search"
                            size="large"
                            value={value}
                            loading={isBusy}
                            onChange={this.handleInputChange}
                            onSearch={this.handleSubmitForm}
                        />
                    </div>

                    <div className={s.root}>
                        {
                            items.map(({id, ...props}) => (
                                <Component
                                    onDeleted={() => {
                                        onDeletedItem(id);
                                    }}
                                    key={id}
                                    {...props}
                                />
                            ))
                        }
                    </div>
                </>
            );
        }
    }
}

export default hoc(Card,  []);